import React, { useState, useEffect, useContext } from 'react';
import { BsPlusCircleFill } from "react-icons/bs"
import { FaAlignJustify, FaCog, FaPen } from "react-icons/fa"
import { Row, Col, Card } from 'react-bootstrap'
import { Link } from "react-router-dom";

import Get from '../../../api/Get'
import { ACCOUNT_ALL } from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import LoadingList from "../../../loader/LoadingList";
import TableSearch from '../../../components/TableSearch';
import ComponentModalErrorSever from '../../../components/ComponentModalErrorSever';

function CuentasList({ url }){
    const [loading, setLoading] = useState(false)
    const [cuentas, setCuentas] = useState([])

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const { auth } = useContext(authContext)
    let accesToken = auth?.data?.access_token;

    //Cargar la lista de cuentas
    useEffect(() => {
        let mounted = true
        Get({url: ACCOUNT_ALL, access_token: accesToken})
        .then((resp) => {
            if(mounted){
                setCuentas(resp.data.data.response.content)
                setLoading(false)
            }            
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
        return () => mounted = false
    }, [])

    const actions = (cell, row) => <div key={`acciones-${row?.id}`}>
        <ul key={row?.id} className="list-inline mb-0">
            <li className="list-inline-item">
                <Link to={`${url}/create?id=${row.id}`}>
                    <FaPen className='iconAction colorNaranja' />
                </Link>
            </li>
            <li className="list-inline-item">
                <Link to={`${url}/fields/${row.id}`}>
                    <FaCog className='iconAction text-secondary' />
                </Link>
            </li>
            <li className="list-inline-item">
                <Link to={`${url}/conf/${row.id}`}>
                    <FaAlignJustify className='iconAction text-secondary' />
                </Link>
            </li>
        </ul>          
    </div>
        
    const columns = [
        {
            text: 'ID',
            dataField: 'id',
            hidden: true
        },  {
            text: 'NOMBRE',
            dataField: 'name',
            headerStyle: { width: '25%' },
        },{
            text: 'PARTNER',
            dataField: 'partner.name',
            headerStyle: { width: '25%' }
        },  {
            text: 'ACTIVO',
            dataField: 'active',
            headerStyle: {  width: '15%', textAlign: 'center' },
            style:{
                textAlign: 'center'
            },
            formatter: (cell) => `${cell ? 'Si': 'No'}`,
        }, {
            text: 'VALIDACIÓN AUT.',
            dataField: 'automaticValidation',
            headerStyle: {  width: '15%', textAlign: 'center' },
            style:{
                textAlign: 'center'
            },
            formatter: (cell) => `${cell ? 'Si': 'No'}`,
        },{
            text: 'Grabación AUT.',
            dataField: 'allowRecord',
            headerStyle: {  width: '15%', textAlign: 'center' },
            style:{
                textAlign: 'center'
            },
            formatter: (cell) => `${cell ? 'Si': 'No'}`,
        }, {
            text: 'PAGO AUT.',
            dataField: 'automaticPaid',
            headerStyle: {  width: '15%', textAlign: 'center' },
            style:{
                textAlign: 'center'
            },
            formatter: (cell) => `${cell ? 'Si': 'No'}`,
        },{
            dataField: '',
            text: 'ACCIONES',
            isDummyField: true,
            headerStyle: {  width: '5%', textAlign: 'center' },
            style:{
                textAlign: 'center'
            },
            formatter: actions,
        }
    ]

    return(<>
        { loading && <LoadingList texto='' /> }
        <Row>
            <Col xs="12" md="8">
                <h2 className="mb-0 title-top"> Cuentas </h2>
            </Col>
            <Col xs="12" md="4" className='text-right'>
                <Row className="align-items-center">
                    <Col>
                    </Col>
                    <Col xs="4" md="3">
                        <Link to={`${url}/create`}><BsPlusCircleFill className="add-btn"/></Link>                        
                    </Col>
                </Row>    
            </Col>
        </Row>
        <Row>
            <Col>
                <Card className="shadow-1 mt-3">
                    <Card.Body>
                        <TableSearch columns={columns} items={cuentas} className="th-text-uppercase"/>                                    
                    </Card.Body> 
                </Card>
            </Col>
        </Row>    
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />    
    </>)
}

export default CuentasList